import { createSelector } from 'reselect';
import { statusOptions } from 'state/status/initial.state';

const getState = (state) => state.status;

const getSystemIsDown = createSelector(
  getState,
  (state) => state.status === statusOptions.DOWN
);

const getConsecutiveNumberOfFailures = createSelector(
  getState,
  (state) => state.consecutive_failures
);

export default {
  getSystemIsDown,
  getConsecutiveNumberOfFailures,
};
